<div class="modal">
    <header class="modal-header">
        <div class="close-button" (click)="closeModal()">
            <i class="ju ju-close"></i>
        </div>
        <span class="title">Gateway Seriennummer bearbeiten</span>
    </header>

    <div class="modal-content">
        <div class="data-content">
            <div class="card">
                <div class="card-content">
                    <div class="input-group">
                        <label [for]="'serialNumber'">Seriennummer</label>
                        <div class="flex-row">
                            <div>{{ serialNumberStartString }}</div>
                            <input [name]="'serialNumber'"
                                   [id]="'serialNumber'"
                                   type="text"
                                   required
                                   pattern="^\d{4}$"
                                   [(ngModel)]="serialNumberLastFourDigits"
                                   (ngModelChange)="setUpTheWholeSerialNumber($event)"
                                   #serialNumberModel="ngModel"
                                   placeholder="Seriennummer"/>
                        </div>
                    </div>
                    <div class="error"><span *ngIf="showError(serialNumberModel)">Ungültiges Seriennummernformat.</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="action-row">
                <button class="primary button-overly" (click)="closeModal()">
                    <i class="ju ju-close"></i>
                    Abbrechnen
                </button>
                <button class="primary button-overly" (click)="saveSerialNumberAndResetLS()">
                    <i class="ju ju-check"></i>
                    Speichern und Daten löschen
                </button>
            </div>
        </div>
    </div>
</div>
